module.exports = __webpack_public_path__ + "assets/img/15-m.3327a41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/15-m.jpg
// module id = a7Of
// module chunks = 0